import PropTypes from 'prop-types';

export const PaginationType = PropTypes.shape({
  next: PropTypes.number,
  prev: PropTypes.number,
  count: PropTypes.number,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number
}).isRequired;

export const QueryType = PropTypes.shape({
  $search: PropTypes.string.isRequired,
  stringify: PropTypes.func.isRequired,
  overwrite: PropTypes.func.isRequired,
}).isRequired;


// WEBPACK FOOTER //
// ./src/GLOBAL_TYPES.js